import { Component } from '@angular/core';
import { AuthenticationService } from '../../providers/authentication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  public menu: string;
  constructor(public auth: AuthenticationService) {
    if (this.auth.auth_data === 'loged') {
      this.menu = 'loged';
    } else {
      this.menu = 'unloged';
    }
  }

}



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/components/header/header.component.ts